module.exports = __webpack_public_path__ + "img/sj-b.cfc7fb57.png";